import { createI18n } from 'vue-i18n'
import { et } from '@/locales/et'

export const i18n = createI18n({
    legacy: false,
    locale: 'et',
    fallbackLocale: 'en',
    messages: {
        et
    }
})